import axios from "axios";
import { useRef, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import BASE_URL from "../constants/baseURL";
import { alert } from "../redux/slices/alertSlice";
import { apiError } from "../redux/slices/loaderSlice";
import { deleteAccessToken } from "../redux/slices/memberSlice";

export default function useAxios({
  baseURL = "mox_api",
  customBaseURL = "",
  customAuthToken = "",
  disableAuthToken = false,
} = {}) {
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.memberDetails);

  const axiosInstance = useRef(axios.create());

  useEffect(() => {
    axiosInstance.current = axios.create({
      headers: {
        ...(!disableAuthToken && {
          Authorization: customAuthToken || authToken,
        }),
        //authorization: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
        "content-type": "application/json",
        "x-api-key": "ziYSCXNw9J50ayP3HdV9N2hC3FL90SIL4OUOmB4T",
      },

      ...(Boolean(customBaseURL)
        ? { baseURL: customBaseURL }
        : {
            baseURL: BASE_URL[baseURL].url + BASE_URL[baseURL].version,
          }),

      validateStatus: (status) => status < 500,
    });
  }, [authToken, baseURL, customAuthToken, customBaseURL, disableAuthToken]);

  return useCallback(
    ({
      url,
      method = "GET",
      data,
      params,
      disableRedirect = false,
      disableError = false,
      customAuthToken,
    }) =>
      axiosInstance
        .current({
          url: url,
          method: method,
          data: data,
          params: params,
          headers: {
            ...(!disableAuthToken && {
              Authorization: customAuthToken,
            }),
          },
        })
        .then((response) => {
          if (response.data.detail?.code === "#401") {
            dispatch(
              alert({
                message:
                  "Could not validate your credentials. Please log in again",
                type: "error",
              })
            );
            return dispatch(deleteAccessToken());
          }

          if (response.status > 201 || !response.data.status) {
            if (!disableError) {
              dispatch(
                alert({
                  message:
                    response.message?.displayMessage || "Something went wrong!",
                  type: "error",
                })
              );
            }

            if (!disableRedirect) {
              dispatch(apiError(response.data?.message?.traceID));

              throw new Error();
            } else {
              return { status: false, message: response.data.error };
            }
          }

          return response.data;
        }),
    [dispatch]
  );
}
